import { form, a2pConsentEnabled, businessName } from "../../../js/utils/variables";

const renderUIEditInfoLead = (lead) => {
    const container = document.querySelector('.verifyInformation__container')
    if (!container) return

    const card = container.querySelector('.card');
    card.innerHTML = "";

    const languageDropdownHTML = form?.show_language_dropdown ? `
        <div class="info__lead verify-infor__input language-input">
            <label>Preferred Language</label>
            <div class="language__dropdown-verify"></div>
        </div>
    ` : '';

    const practiceNameText = businessName || '[Business Name]';

    let consentHTML = '';
    if (a2pConsentEnabled) {
        consentHTML = `
            <div class="note__wrapper sms-consent__wrapper verify-info-consent">
                <div class="consent-row sms-consent-transactional-row">
                    <span class="noteOption__checkbox sms-consent-transactional-checkbox" role="button" tabindex="0" aria-label="Transactional and informational SMS consent"><i class="ri-check-line"></i></span>
                    <label class="sms-consent-label">I agree to receive transactional SMS from <span class="sms-consent-business-name">${practiceNameText}</span> (e.g. verification codes, account & care messages).</label>
                </div>
                <div class="consent-row terms-privacy-row">
                    <span class="noteOption__checkbox terms-privacy-checkbox" role="button" tabindex="0" aria-label="Accept Terms and Conditions and Privacy Policy"><i class="ri-check-line"></i></span>
                    <label class="sms-consent-label terms-privacy-label">I accept the <u class="link terms-link">Terms and Conditions</u> and <u class="link privacy-link">Privacy Policy</u>.</label>
                </div>
                <div class="consent-row sms-consent-promotional-row">
                    <span class="noteOption__checkbox sms-consent-promotional-checkbox" role="button" tabindex="0" aria-label="Promotional and marketing SMS consent"><i class="ri-check-line"></i></span>
                    <label class="sms-consent-label">I agree to receive promotional SMS from <span class="sms-consent-business-name">${practiceNameText}</span>.</label>
                </div>
                <p class="sms-consent-disclaimer">Msg & data rates may apply. Message frequency varies. Reply STOP to opt out, HELP for help.</p>
            </div>
        `;
    }

    card.insertAdjacentHTML('afterbegin', `
        <div class="verify-infor__body edit">
            <div class="info__lead verify-infor__input full_name-input ${!lead?.first_name || !lead?.last_name ? "invalid" : ""}">
                <label>Full Name <span class='text__required'>* Required</span></label>
                <input
                    type="text"
                    placeholder="Enter your full name"
                    value="${[lead?.first_name, lead?.last_name].filter(Boolean).join(' ')}"
                />

            </div>
            <div class="info__lead verify-infor__input email-input">
                <label>Email address</label>
                <input type="text" placeholder="Enter your email address" value="${lead?.email ? lead?.email : ""}" />
            </div>
            <div class="info__lead verify-infor__input phone-input ${!lead?.phone ? "invalid" : ""}">
                <label>Phone number <span class='text__required'>* Required</span></label>
                <input type="text" placeholder="Enter your phone number" value="${lead?.phone ? lead?.phone : ""}" />
            </div>
            ${languageDropdownHTML}
            ${consentHTML}
        </div>
    `)
}

export {
    renderUIEditInfoLead
}
